<template>
  <div class="animated fadeIn" v-if="pageLoaded">
    <div v-if="pageLoaded">
      <span v-show="false">{{ reactivity }}</span>
      <!-- loading component -->
      <Loading />
      <b-card>
        <div class="d-flex justify-content-center mt-3"></div>

        <b-card-body>
          <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <template v-slot:header>
              <h4 class="mb-0">
                اطلاعات پژوهشی دانشگاه "{{ demand.university }}"
              </h4>
            </template>

            <b-tabs pills v-model="tabIndex">
              <b-tab title="اطلاعات ثبت شده" active lazy>
                <b-card
                  header-bg-variant="green"
                  header-text-variant="white"
                  header="موضوعات تعریف شده برای این دانشگاه"
                  style="border: 0"
                  class="shadow p-3 mb-5 bg-white rounded mt-0"
                >
                  <div v-if="uniCats.length">
                    <ol class="p-2">
                      <li v-for="(item, index) in uniCats" :key="item.id">
                        {{ index + 1 }}. {{ item.name }}
                      </li>
                    </ol>
                  </div>
                  <div v-else>
                    <i
                      class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                      aria-hidden="true"
                    ></i>
                    <p class="mt-2 ml-2 text-danger">
                      موضوع فعالیت برای این دانشگاه تعریف نشده است.
                    </p>
                  </div></b-card
                >
                <b-card-text>
                  <b-card
                    style="border: 0"
                    class="shadow p-3 mb-5 bg-white rounded mt-0"
                  >
                    <div class="row">
                      <div class="col">
                        <h5 class="mb-0">
                          آیا ماموریت پیشنهادی سامانه مورد تایید دانشگاه است؟
                        </h5>
                      </div>
                      <div class="col">
                        <v-btn
                          class="bc-green text-white btn-radius float-end"
                          width="150"
                          height="45"
                          elevation="0"
                          :disabled="isSaving || !excelCats.length"
                          @click="$refs.table2.$el.click()"
                        >
                          <span class="fs-small">
                            خروجی موضوعات
                            <v-icon>$Excel</v-icon></span
                          >
                        </v-btn>
                        <vue-excel-xlsx
                          v-show="false"
                          ref="table2"
                          :data="excelCats"
                          :columns="excelCatsFields"
                          :filename="'موضوعات ثبت شده'"
                          :sheetname="currentDate"
                        >
                          دریافت اکسل
                        </vue-excel-xlsx>
                      </div>
                    </div>
                    <div class="row">
                      <b-form-group>
                        <div class="d-flex" dir="rtl">
                          <b-form-checkbox
                            v-model="isConfirmed"
                            :disabled="true"
                          ></b-form-checkbox>
                          <label class="ml-2"
                            ><h6>
                              بله، ماموریت فوق با فعالیت‌های دانشگاه هماهنگ است.
                            </h6></label
                          >
                        </div>
                      </b-form-group>
                    </div>
                    <div class="row">
                      <b-form-group>
                        <div class="d-flex" dir="rtl">
                          <b-form-checkbox
                            v-model="isChange"
                            :disabled="true"
                          ></b-form-checkbox>
                          <label class="ml-2"
                            ><h6>
                              خیر، دانشگاه حوزه دیگری را به عنوان ماموریت اصلی
                              پیشنهاد می‌دهد.
                            </h6></label
                          >
                        </div>
                      </b-form-group>
                    </div></b-card
                  >

                  <b-card
                    style="border: 0; background-color: #79a9d1"
                    class="shadow p-3 mb-5 rounded mt-0"
                    v-if="isChange"
                  >
                    <div class="row">
                      <div class="col">
                        <h5 class="mb-0">موضوعات انتخاب شده توسط دانشگاه:</h5>
                      </div>
                    </div>

                    <div v-if="uniCatIds.length">
                      <ol class="p-2">
                        <li v-for="(item, index) in uniCatIds" :key="item.id">
                          {{ index + 1 }}. {{ item.name }}
                        </li>
                      </ol>
                    </div>
                  </b-card>
                  <b-card
                    style="border: 0; background-color: #e8f6f3"
                    class="shadow p-3 mb-5 rounded mt-0"
                  >
                    <div class="row">
                      <div class="col">
                        <h5 class="mb-0">محور(های) انتخاب شده توسط دانشگاه:</h5>
                      </div>
                    </div>

                    <div v-if="uniMehvarIds.length">
                      <ol class="p-2">
                        <li
                          v-for="(item, index) in uniMehvarIds"
                          :key="item.id"
                        >
                          {{ index + 1 }}. {{ item.name }}
                        </li>
                      </ol>
                    </div>
                  </b-card>
                  <b-card
                    style="border: 0"
                    class="shadow p-3 mb-5 bg-white rounded mt-0"
                  >
                    <b-form-group label="خلاصه پروژه‌های پژوهشی" class="my-3">
                      <b-form-file
                        :disabled="true"
                        :placeholder="
                          researchAbstractFileData
                            ? researchAbstractFileData.name
                            : ''
                        "
                      ></b-form-file>
                    </b-form-group>
                    <b-form-group>
                      <b-row>
                        <b-col>
                          <b-row
                            align-h="end"
                            v-if="Object.keys(researchAbstractFileData).length"
                          >
                            <span class="mt-3 ml-2" style="float: left"
                              ><a
                                class="btn btn-success white--text"
                                :href="researchAbstractFileData.url"
                                target="_blank"
                                >دریافت</a
                              ></span
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-form-group>
                    <hr />
                    <b-form-group label="خلاصه پروژه‌های صنعتی" class="my-3">
                      <b-form-file
                        :disabled="true"
                        :placeholder="
                          industryAbstractFileData
                            ? industryAbstractFileData.name
                            : ''
                        "
                      ></b-form-file>
                    </b-form-group>
                    <b-form-group>
                      <b-row>
                        <b-col>
                          <b-row
                            align-h="end"
                            v-if="Object.keys(industryAbstractFileData).length"
                          >
                            <span class="mt-3 ml-2" style="float: left"
                              ><a
                                class="btn btn-success white--text"
                                :href="industryAbstractFileData.url"
                                target="_blank"
                                >دریافت</a
                              ></span
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-form-group>
                    <hr />
                    <b-form-group
                      label="معرفی مراکز یا آزمایشگاه‌های فعال در حوزه پیشنهادی"
                      class="my-3"
                    >
                      <b-form-file
                        :disabled="true"
                        :placeholder="
                          centersAbstractFileData
                            ? centersAbstractFileData.name
                            : ''
                        "
                      ></b-form-file>
                    </b-form-group>
                    <b-form-group>
                      <b-row>
                        <b-col>
                          <b-row
                            align-h="end"
                            v-if="Object.keys(centersAbstractFileData).length"
                          >
                            <span class="mt-3 ml-2" style="float: left"
                              ><a
                                class="btn btn-success white--text"
                                :href="centersAbstractFileData.url"
                                target="_blank"
                                >دریافت</a
                              ></span
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-form-group>
                    <hr />
                    <b-form-group
                      label="معرفی اعضای هیئت علمی شاخص"
                      class="my-3"
                    >
                      <b-form-file
                        :disabled="true"
                        :placeholder="
                          committeesAbstractFileData
                            ? committeesAbstractFileData.name
                            : ''
                        "
                      ></b-form-file>
                    </b-form-group>
                    <b-form-group>
                      <b-row>
                        <b-col>
                          <b-row
                            align-h="end"
                            v-if="
                              Object.keys(committeesAbstractFileData).length
                            "
                          >
                            <span class="mt-3 ml-2" style="float: left"
                              ><a
                                class="btn btn-success white--text"
                                :href="committeesAbstractFileData.url"
                                target="_blank"
                                >دریافت</a
                              ></span
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-form-group>
                    <hr />
                    <b-row class="mb-2 pt-2 my-1" align-v="center">
                      <h5 class="mt-2 ml-2">مقالات ISI</h5>
                      <v-col>
                        <v-btn
                          class="bc-primary text-white btn-radius float-end"
                          width="150"
                          height="45"
                          elevation="0"
                          :disabled="isSaving || !articles.length"
                          @click="$refs.table1.$el.click()"
                        >
                          <span class="fs-small">
                            خروجی مقالات
                            <v-icon>$Excel</v-icon></span
                          >
                        </v-btn>
                        <vue-excel-xlsx
                          v-show="false"
                          ref="table1"
                          :data="articles"
                          :columns="excelArticleFields"
                          :filename="'مقالات ثبت شده'"
                          :sheetname="currentDate"
                        >
                          دریافت اکسل
                        </vue-excel-xlsx>
                      </v-col>
                    </b-row>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="articles"
                      :fields="articlesField"
                      empty-text="مقاله‌ای برای نمایش وجود ندارد"
                      class="table table-secondary mb-2"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      ],
                      <template v-slot:cell(operation)="data">
                        <div>
                          <b-button
                            variant="primary"
                            class="mr-2"
                            :disabled="true"
                            @click="doiCheck(data.index)"
                            >بررسی</b-button
                          >
                        </div>
                      </template>

                      <template v-slot:cell(doi)="data">
                        <div>
                          <b-form-input
                            dir="ltr"
                            trim
                            v-model="data.item.doi"
                            type="text"
                            :disabled="true"
                          ></b-form-input>
                        </div>
                      </template>
                    </b-table>
                    <hr />
                    <b-row class="mb-2 pt-2 my-1" align-v="center">
                      <h5 class="mt-2 ml-2">
                        سایر مستندات (گرنت‌های تحقیقاتی ملی و
                        بین‌المللی/شرکت‌های دانش‌بنیان وابسته/ثبت اختراع و
                        پتنت‌های بین‌المللی)
                      </h5>
                    </b-row>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="otherFiles"
                      :fields="otherFilesField"
                      empty-text="فایلی برای نمایش وجود ندارد"
                      class="table table-secondary mb-2"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      ],
                      <template v-slot:cell(operation)="data">
                        <b-row>
                          <b-col cols="8">
                            <b-row>
                              <b-col>
                                <b-row
                                  align-h="end"
                                  v-if="Object.keys(data.item.file).length"
                                >
                                  <span class="mt-3 ml-2" style="float: left"
                                    ><a
                                      class="btn btn-success white--text"
                                      :href="data.item.file.url"
                                      target="_blank"
                                      >دریافت</a
                                    ></span
                                  >
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </template>

                      <template v-slot:cell(description)="data">
                        <div>
                          <b-form-input
                            dir="rtl"
                            trim
                            v-model="data.item.description"
                            type="text"
                            :disabled="true"
                          ></b-form-input>
                        </div>
                      </template>
                    </b-table>
                  </b-card>
                  <b-card
                    style="border: 0; background-color: #96e8fd"
                    class="shadow p-3 mb-5 rounded mt-0"
                  >
                    <div class="row">
                      <div class="col">
                        <h5 class="mb-0">اطلاعات تماس با رابط دانشگاه</h5>
                      </div>
                    </div>

                    <b-form-group class="my-3">
                      <div class="my-3">
                        <b-form-group label="نام رابط" label-for="contact-name">
                          <b-form-input
                            id="contact-name"
                            dir="rtl"
                            trim
                            v-model="contanctName"
                            type="text"
                            :disabled="true"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group label="سمت رابط" label-for="contact-role">
                          <b-form-input
                            id="contact-role"
                            dir="rtl"
                            trim
                            v-model="contanctRole"
                            type="text"
                            :disabled="true"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          label="شماره همراه رابط"
                          label-for="contact-mobile"
                        >
                          <b-form-input
                            dir="rtl"
                            trim
                            v-model="contanctMobile"
                            type="number"
                            :disabled="true"
                          />
                        </b-form-group>
                      </div>
                    </b-form-group>
                  </b-card>
                  <!-- finalize -->
                  <b-card
                    style="border: 0"
                    class="shadow p-3 mb-5 bg-white rounded mt-0"
                    v-if="
                      demand.status == 'ارسال نامه تاییدیه' ||
                      demand.status == 'تایید نهایی'
                    "
                  >
                    <div class="row">
                      <div class="col">
                        <h4 class="mb-0">نامه تاییدیه حوزه فعالیت</h4>
                      </div>
                    </div>

                    <b-form-group class="my-3">
                      <b-form-file
                        :disabled="true"
                        :placeholder="
                          finalLetterFileData ? finalLetterFileData.name : ''
                        "
                      ></b-form-file>
                    </b-form-group>
                    <b-form-group>
                      <b-row>
                        <b-col>
                          <b-row
                            align-h="end"
                            v-if="Object.keys(finalLetterFileData).length"
                          >
                            <span class="mt-3 ml-2" style="float: left"
                              ><a
                                class="btn btn-success white--text"
                                :href="finalLetterFileData.url"
                                target="_blank"
                                >دریافت</a
                              ></span
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-card>
                </b-card-text></b-tab
              >
              <b-tab title="تاریخچه" lazy>
                <b-card
                  :bg-variant="computedVariant(index)"
                  v-for="(p, index) in history"
                  :key="index"
                  style="max-width: 80%"
                  class="mb-3 border-0 shadow"
                >
                  <template slot="header">
                    <b-row>
                      <b-col>
                        <h5>{{ p.name }}</h5>
                      </b-col>
                      <b-col>
                        <div style="float: left">
                          <h5>{{ p.date }}</h5>
                        </div>
                      </b-col>
                    </b-row>
                  </template>

                  <h6>{{ p.message }}</h6>
                </b-card>
              </b-tab>
              <b-tab title="جمعبندی" lazy>
                <b-form-group
                  id="fieldset-1"
                  x
                  description
                  label="وضعیت جمعبندی اطلاعات ارسال شده"
                >
                  <b-form-group>
                    <Select2
                      v-model="decision"
                      :options="situationsOptions"
                      :settings="{ width: '75%' }"
                    ></Select2>

                    <!-- <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select> -->
                  </b-form-group>
                  <div v-if="decision == 1">
                    <b-row>
                      <i
                        class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                        aria-hidden="true"
                      ></i>
                      <p class="mt-2 ml-2 text-danger">
                        تذکر: لطفا توجه داشته باشد که متن نگارش شده توسط شما
                        بدون تغییر در اختیار دانشگاه قرار خواهد گرفت!
                      </p>
                    </b-row>
                  </div>
                  <b-form-group
                    label="یادداشت"
                    class="mt-4"
                    v-if="decision == 1 || decision == 2"
                  >
                    <b-card
                      style="border: 0"
                      class="shadow p-3 mb-5 bg-blue rounded mt-0"
                      v-if="isChange"
                    >
                      <div class="row">
                        <div class="col">
                          <h5 class="mb-0">
                            لطفا موضوعی که آن را به عنوان ماموریت اصلی دانشگاه
                            می‌دانید، از لیست زیر انتخاب نمایید. توجه فرمایید که
                            شما تنها می‌توانید حداکثر دو موضوع را انتخاب نمایید.
                          </h5>
                        </div>
                      </div>

                      <b-form-group class="my-3">
                        <Select2
                          v-model="uniEditCatIds"
                          :options="categories"
                          :settings="{ width: '100%', multiple: true }"
                          :disabled="showMehvarSelection"
                          @select="onSelectCategory"
                        ></Select2>
                      </b-form-group>
                      <div class="d-flex justify-content-center mt-3">
                        <b-button
                          :disabled="
                            showMehvarSelection || !uniEditCatIds.length
                          "
                          class="mx-1"
                          variant="danger"
                          @click="removeCatIds()"
                          >حذف</b-button
                        >
                        <b-button
                          :disabled="
                            showMehvarSelection || !uniEditCatIds.length
                          "
                          class="mx-1"
                          variant="primary"
                          @click="
                            getMehvarByCats(), (showMehvarSelection = true)
                          "
                          >ادامه</b-button
                        >
                      </div>
                    </b-card>
                    <b-card
                      style="border: 0; background-color: #e8f6f3"
                      class="shadow p-3 mb-5 rounded mt-0"
                      v-if="isChange && showMehvarSelection"
                    >
                      <div class="row">
                        <div class="col">
                          <h5 class="mb-0">
                            لطفا محور متناسب با موضوعی که آن را به عنوان ماموریت
                            اصلی دانشگاه می‌دانید، از لیست زیر انتخاب نمایید.
                          </h5>
                        </div>
                      </div>

                      <b-form-group class="my-3">
                        <Select2
                          v-model="uniEditMehvarIds"
                          :options="mehvars"
                          :settings="{ width: '100%', multiple: true }"
                        ></Select2>
                      </b-form-group>
                      <div class="d-flex justify-content-center mt-3">
                        <b-button
                          class="mx-1"
                          variant="success"
                          @click="showMehvarSelection = false"
                          :disabled="!showMehvarSelection"
                          >بازگشت</b-button
                        >
                        <b-button
                          :disabled="!showMehvarSelection"
                          class="mx-1"
                          variant="danger"
                          @click="removeMehvarIds()"
                          >حذف</b-button
                        >
                      </div>
                    </b-card>
                    <b-form-textarea
                      trim
                      id="textarea"
                      v-model="adminMessage"
                      :state="
                        decision == 1 ? (adminMessage ? null : false) : null
                      "
                      width="75%"
                      placeholder="نظرات خود را اینجا وارد نمایید"
                      rows="8"
                      max-rows="10"
                    ></b-form-textarea>

                    <b-form-invalid-feedback
                      id="comments"
                      :state="
                        decision == 1 ? (adminMessage ? null : false) : null
                      "
                      >با نوشتن نظر خود میتوانید دانشگاه را در انجام اصلاحات
                      مورد نیاز راهنمایی کنید!</b-form-invalid-feedback
                    >
                  </b-form-group>
                  <div class="d-flex justify-content-center mt-3">
                    <b-button
                      :disabled="submitButton"
                      :loading="isSaving"
                      class="mx-1"
                      variant="success"
                      @click="submit()"
                      >ثبت</b-button
                    >
                  </div>
                </b-form-group>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
  },
  data() {
    return {
      reactivity: false,
      check: false,
      pageLoaded: false,
      show: false,
      busy: false,
      isSaving: false,
      color: "",
      isLoaded: true,
      demand: {},
      uniCats: [],
      isConfirmed: false,
      isChange: false,
      isProposed: false,
      researchAbstractFile: [],
      researchAbstractFileData: {},
      industryAbstractFile: [],
      industryAbstractFileData: {},
      centersAbstractFile: [],
      centersAbstractFileData: {},
      committeesAbstractFile: [],
      committeesAbstractFileData: {},
      finalLetterFile: [],
      finalLetterFileData: {},
      articles: [{ title: "", doi: "" }],
      otherFiles: [
        {
          description: "",
          fileId: "",
          file: {},
          rawFile: [],
        },
      ],
      articlesField: [
        { key: "index", label: "#" },
        { key: "doi", label: "doi" },
        {
          key: "title",
          label: "عنوان مقاله",
        },
        { key: "operation", label: "عملیات" },
      ],
      excelArticleFields: [
        { field: "index", label: "ترتیب" },
        { field: "doi", label: "doi" },
        { field: "title", label: "عنوان مقاله" },
      ],
      otherFilesField: [
        { key: "index", label: "#" },
        {
          key: "description",
          label: "توضیحات",
        },
        { key: "operation", label: "عملیات" },
      ],
      excelCatsFields: [
        { field: "index", label: "ترتیب" },
        { field: "catName", label: "موضوع" },
        { field: "name", label: "محور" },
      ],
      excelCats: [],
      uniCatIds: [],
      uniMehvarIds: [],
      uniEditCatIds: [],
      uniEditMehvarIds: [],
      contanctName: "",
      contanctRole: "",
      contanctMobile: "",
      history: [],
      tabIndex: 0,
      adminMessage: "",
      decision: "",
      situationsOptions: [
        { id: 1, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 2, eng: "accepted", text: "تایید شده" },
        { id: 3, eng: "finalize", text: "تایید نهایی" },
        { id: 4, eng: "rejected", text: "رد شده" },
      ],
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      categories: [],
      mehvars: [],
      showMehvarSelection: false,
    };
  },

  methods: {
    submit() {
      this.isSaving = true;
      const status = this.situationsOptions.filter(
        (x) => x.id == this.decision
      )[0].eng;
      if (this.decision == 3) {
        this.uniEditCatIds = [];
        this.uniEditMehvarIds = [];
      }

      this.$http
        .patch(
          this.baseUrl +
            "/setad/admin/demand/decision/" +
            this.$route.params.id,
          {
            status: status,
            adminMessage: this.adminMessage,
            catIds: this.uniEditCatIds.length ? this.uniEditCatIds : undefined,
            mehvarIds: this.uniEditMehvarIds.length
              ? this.uniEditMehvarIds
              : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.isSaving = false;
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },

    onMounted() {
      this.isLoaded = false;
      //getting info
      this.$http
        .get(this.baseUrl + "/setad/admin/demand/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.demand = res.data.demand;
          this.history = res.data.history;
          this.researchAbstractFileData = this.demand.researchAbstractFileId
            ? {
                id: this.demand.researchAbstractFileId,
                name: this.demand.researchAbstractFileName,
                url: this.demand.researchAbstractFileUrl,
              }
            : {};
          this.industryAbstractFileData = this.demand.industryAbstractFileId
            ? {
                id: this.demand.industryAbstractFileId,
                name: this.demand.industryAbstractFileName,
                url: this.demand.industryAbstractFileUrl,
              }
            : {};
          this.centersAbstractFileData = this.demand.centersAbstractFileId
            ? {
                id: this.demand.centersAbstractFileId,
                name: this.demand.centersAbstractFileName,
                url: this.demand.centersAbstractFileUrl,
              }
            : {};
          this.committeesAbstractFileData = this.demand.committeesAbstractFileId
            ? {
                id: this.demand.committeesAbstractFileId,
                name: this.demand.committeesAbstractFileName,
                url: this.demand.committeesAbstractFileUrl,
              }
            : {};
          this.finalLetterFileData = this.demand.finalLetterFileId
            ? {
                id: this.demand.finalLetterFileId,
                name: this.demand.finalLetterFileName,
                url: this.demand.finalLetterFileUrl,
              }
            : {};
          this.otherFiles = this.demand.otherFiles.length
            ? this.demand.otherFiles
            : [
                {
                  description: "",
                  fileId: "",
                  file: {},
                  rawFile: [],
                },
              ];
          this.contanctName = this.demand.contanctName;
          this.contanctRole = this.demand.contanctRole;
          this.contanctMobile = this.demand.contanctMobile;
          this.articles = this.demand.articles.length
            ? this.demand.articles
            : [{ title: "", doi: "" }];
          this.isConfirmed = this.demand.isConfirmed;
          this.isChange = this.demand.isChange;
          this.uniCats = this.demand.cats;
          this.uniCatIds = this.demand.catIds;
          this.uniMehvarIds = this.demand.mehvarIds;
          this.uniEditCatIds = this.uniCatIds.map((x) => x.id);
          this.uniEditMehvarIds = this.uniMehvarIds.map((x) => x.id);
          this.isProposed = this.uniMehvarIds.length ? true : false;

          if (this.isConfirmed) {
            this.excelCats = this.uniMehvarIds
              .map((x) => {
                return {
                  id: x.id,
                  name: x.name,
                  catId: x.catId,
                  catName: this.uniCats.length
                    ? this.uniCats.filter((y) => y.id == x.catId).length
                      ? this.uniCats.filter((y) => y.id == x.catId)[0].name
                      : ""
                    : "",
                };
              })
              .filter((x) => x.catName)
              .sort((a, b) => a.catId - b.catId);
          }
          if (this.isChange) {
            try {
              this.excelCats = this.uniMehvarIds
                .map((x) => {
                  return {
                    id: x.id,
                    name: x.name,
                    catId: x.catId,
                    catName: this.uniCats.length
                      ? this.uniCatIds.filter((y) => y.id == x.catId).length
                        ? this.uniCatIds.filter((y) => y.id == x.catId)[0].name
                        : ""
                      : "",
                  };
                })
                .filter((x) => x.catName)
                .sort((a, b) => a.catId - b.catId);
            } catch (error1) {
              this.excelCats = [];
              console.log(error1);
            }
          }

          setTimeout(() => {
            // NOTE (m-setTimeout) to set timeout for 200 ms
            this.show = true;
            this.pageLoaded = true;
          }, 200);
        })
        .catch((err) => {
          console.log(err);
          if (err.response) this.toast(err.response.data, "error");
        });

      this.$bvModal.show("loading");
      this.isLoaded = true;
    },
    getCats() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/cats/list",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.categories = res.data.map((x) => {
            return {
              id: x.id,
              text: x.name,
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSelectCategory() {
      if (this.uniEditCatIds.length > 2) {
        this.uniEditCatIds.pop();
        this.toast("فقط می‌توانید حداکثر دو دسته انتخاب کنید.", "error");
      }
    },
    removeCatIds() {
      this.uniEditCatIds = [];
      this.uniEditMehvarIds = [];
    },
    getMehvarByCats() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/mehvarByCats",
          { catIds: this.uniEditCatIds },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          this.uniEditMehvarIds = this.uniEditMehvarIds.filter((id) =>
            this.mehvars.find((item) => item.id === id)
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeMehvarIds() {
      this.uniEditMehvarIds = [];
    },
    computedVariant(seed) {
      let variant = [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "dark",
        "info",
        "light",
      ];
      return variant[seed % 8];
    },
  },
  computed: {
    submitButton() {
      if (this.isSaving) return true;
      else {
        if (this.decision) {
          if (this.decision == 3) return false;
          else if (this.decision == 2) {
            if (this.isChange) {
              if (!this.uniEditCatIds.length) return true;
              else if (!this.uniEditMehvarIds.length) return true;
              else return false;
            } else return false;
          } else if (this.decision == 1) {
            if (this.isChange) {
              if (!this.uniEditCatIds.length) return true;
              else if (!this.uniEditMehvarIds.length) return true;
              else if (!this.adminMessage) return true;
              else return false;
            } else if (this.adminMessage) return false;
            else return true;
          } else return true;
        } else return true;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.onMounted();
    this.getCats();
  },
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
ul {
  list-style: disc !important;
  padding-right: 1.5rem !important;
}
.dialog-card {
  border-radius: 15px !important;
  padding: 25px;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
